import { render, staticRenderFns } from "./intelligence.vue?vue&type=template&id=2a8fb77c&scoped=true"
import script from "./intelligence.vue?vue&type=script&lang=js"
export * from "./intelligence.vue?vue&type=script&lang=js"
import style0 from "./intelligence.vue?vue&type=style&index=0&id=2a8fb77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8fb77c",
  null
  
)

export default component.exports